import { useCmsText } from "../../hooks/useCmsText";
import type { ComposerApi } from "../useRequestComposer";
import { Postcard } from "./Postcard";

/**
 * Esito: la cartolina inviata, timbrata, e i testi del CMS («Richiesta
 * inviata!», «…al più presto»). Il focus va sul titolo. Nel pannello il
 * pulsante dice «OK» e riporta a una richiesta nuova; nella pagina «Nuova
 * richiesta». Nessuna promessa in più: non esiste un'email di conferma.
 */
export function SuccessView({ api, variant, wide }: { api: ComposerApi; variant: "page" | "panel"; wide: boolean }) {
  const ct = useCmsText("contact");
  const { t, state } = api;
  const s = state.snapshot;
  if (!s) return null;
  return (
    <div className={`rq-success ${wide ? "rq-success--wide" : "rq-success--narrow"}`} data-gb="esito">
      <div className="rq-success__text">
        <h3 ref={api.setEl("success")} tabIndex={-1} data-rq-focus-target className="rq-success__title">{ct("sentTitle")}</h3>
        <p className="rq-success__sub">{ct("sentSubtitle")}</p>
        {s.email && <p className="rq-success__mail">{t("contact.guide.success.replyTo", { email: s.email })}</p>}
        <button type="button" className="rq-btn rq-btn--ghost" data-gb="ok" onClick={api.dismissSuccess}>
          {variant === "panel" ? t("contact.guide.ok") : t("contact.guide.success.again")}
        </button>
      </div>
      <Postcard
        t={t}
        free
        message={s.message}
        headline={s.headline}
        name={s.name}
        company={s.company}
        email={s.email}
        phone={s.phone}
        stamps={s.stamps}
        stamped
      />
    </div>
  );
}
